export const StyleRoutes = {
  path: 'style/*',
  lazy: () => import('../pages/style'),
};
